<template>
  <v-container class="GradesPage py-5">
    <h1>Academic success</h1>
    <v-data-table
      item-key="name"
      loading
      loading-text="Loading... Please wait"
      class="elevation-1 mt-6"
    />
  </v-container>
</template>

<script>
export default {
  name: 'GradesPage',
};
</script>
